import { format } from 'date-fns';

export const getServerTime = () => {
  const saoPauloTimeZone = 'America/Sao_Paulo';
  const currentTimeInSaoPaulo = new Date().toLocaleString('en', { timeZone: saoPauloTimeZone });
  const formattedCurrentTime = format(new Date(currentTimeInSaoPaulo), 'yyyy-MM-dd HH:mm:ss');
  const currentTimeInMilliseconds = new Date(formattedCurrentTime).getTime();

  return {
    formattedTime: formattedCurrentTime,
    timestamp: currentTimeInMilliseconds,
  };
};
